module.exports = __webpack_public_path__ + "img/w3_filter_dark.3c0fe98d.png";